import { Box, Drawer } from '@mui/material';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { NavSectionVertical } from 'src/components/nav-section';
import { NAVBAR } from 'src/config';
import useResponsive from 'src/hooks/useResponsive';

import NavbarAccount from './NavbarAccount';
import navConfig from './NavConfig';

export default function NavbarVertical({ isOpenSidebar, onCloseSidebar }) {
  const { pathname } = useLocation();
  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
  }, [pathname, isOpenSidebar, onCloseSidebar]); // Added missing dependencies

  return (
    <Box
      sx={{
        width: {
          lg: NAVBAR.DASHBOARD_WIDTH, // Always use full width on desktop for simplicity
        },
      }}
    >
      {isDesktop && (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAVBAR.DASHBOARD_WIDTH,
              borderRightStyle: 'dashed',
              bgcolor: 'background.default',
              marginTop: '101px',
            },
          }}
        >
          <NavbarAccount /> {/* Removed unnecessary prop, assuming it's handled internally */}
          <NavSectionVertical navConfig={navConfig} /> {/* Simplified nav section rendering */}
        </Drawer>
      )}
    </Box>
  );
}
